export const NAME_MAX_LENGTH = 100;
export const EMAIL_MAX_LENGTH = 254;

export const namePattern = /^[\p{L}\p{M}\p{Zs}.'’-]+$/u;

export const emailPattern = /\S[^\s@]*@\S+\.\S+/;

export const pidPattern = /^\d{1,20}$/;

const MONTH = '(0[1-9]|1[0-2])';
const DAY = '(0[1-9]|[12]\\d|3[01])';
const SEPARATOR = '[-/.]';
const datePattern = new RegExp(
  `^(\\d{4}${SEPARATOR}${MONTH}${SEPARATOR}${DAY}|${MONTH}${SEPARATOR}${DAY}${SEPARATOR}\\d{4})$`,
);

export const validateSearchValue = (value: string): boolean => {
  if (value === '') {
    return true;
  }

  return (
    namePattern.test(value) || pidPattern.test(value) || datePattern.test(value)
  );
};

export function validateDatePattern(date: string): boolean {
  return datePattern.test(date);
}

export function validateNamePattern(name: string): boolean {
  return namePattern.test(name);
}

export function validateNameLength(name: string): boolean {
  return name.length <= NAME_MAX_LENGTH;
}

export function validatePID(pid: string): boolean {
  return pidPattern.test(pid);
}

export function validatePIDLength(pid: string): boolean {
  return pid.length <= 20;
}
